export default __webpack_public_path__ + "static/media/logo2.a2267f63.png";